var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.type === 'paragraph')?_c('p',{class:_vm.$style.p},_vm._l((_vm.nodes),function(node,i){return _c('RichTextNode',{key:i,attrs:{"data":node}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }